import React from "react";
import Constants from "../../Constants";
import { withRouter } from "react-router-dom";
const ModelItemLarge = ({ model, history, setShowSearch }) => {
  const modelSlug = model.model_name.replace(/ /g, "-").toLowerCase();
  //
  return (
    <div
      className="model_search_item"
      onClick={() => {
        setShowSearch(false);
        history.push(`${Constants.HOME}girl/${modelSlug}/${model.id}`);
      }}
    >
      <div className="model_search_img">
        <img
          src={`${Constants.STATIC}models/${model.id}-${modelSlug}.jpg`}
          alt={model.model_name}
        />
      </div>
      <div className="model_search_content">
        <div className="">
          <div className="model_search_title">
            <span>
              <strong>{model.model_name}</strong>
            </span>
          </div>
        </div>
        <div className="model_search_info">
          <div className="model_search_count">
            {model.likes} Likes | {Math.ceil(model.model_views / 1000)}k Views
          </div>
        </div>
      </div>
      <i className="icon-arrow-right"></i>
    </div>
  );
};

export default withRouter(ModelItemLarge);
